export default function () {
  this.getTotalAgendasActives()
}



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/components/statistics/resources/mounted.js